<section class="ids-m-2 toast-container">
  <section *ngFor="let toast of toasts" class="ids-mt-3 ids-mb-3">
    <ids-alert show icon variant="{{ toast.showType }}" [(show)]="toast.show">
      {{ toast.message }}
    </ids-alert>
  </section>
</section>
